import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
export interface HelpDialogModel {
  type?: 'cookies' | 'help' | 'statistics_configurations' | '';
  show: boolean
}

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  private subjetHelpController: BehaviorSubject<HelpDialogModel> = new BehaviorSubject<HelpDialogModel>({ show: false });

  public helpController: Observable<HelpDialogModel> = this.subjetHelpController.asObservable().pipe(filter(v => !!v?.type));

  constructor(private http: HttpClient) { }

  sendHelp(data: any) {
    const formData: any = new FormData();
    formData.append('title', data.title);
    formData.append('description', data.description);
    if (data.files) {
      data.files.forEach((files: string) => {
        formData.append('files', files);
      })
    }

    return this.http.post(`${environment.URL_API}notify/incidence`, formData);
  }

  showHelp() {
    this.subjetHelpController.next({ show: true, type: 'help' });
  }

  hideHelp() {
    this.subjetHelpController.next({ show: false, type: 'help' });
  }

  showCookies() {
    this.subjetHelpController.next({ show: true, type: 'cookies' });
  }

  hideCookies() {
    this.subjetHelpController.next({ show: false, type: 'cookies' });
  }

  showStatisticsConfigurations() {
    this.subjetHelpController.next({ show: true, type: 'statistics_configurations' });
  }

  hideStatisticsConfigurations() {
    this.subjetHelpController.next({ show: false, type: 'statistics_configurations' });
  }
}
